import { AxiosResponse } from 'axios';
import { APIError } from '~/domain/api/errors';
import apiProducer from '../api';

type Find = {
  startDate: string;
  endDate: string;
};

export const find = async ({ startDate, endDate }: Find) => {
  try {
    const URL = `/weeks?startDate=${startDate}&finalDate=${endDate}`;
    const response: AxiosResponse = await apiProducer.get(URL);
    return response;
  } catch (error: any) {
    const { data: dataError } = error.response;
    const { Status: errorStatus } = dataError;

    if (typeof dataError === 'string') {
      throw new APIError(String(dataError));
    }

    if ([400, 500].includes(errorStatus)) {
      throw new APIError(String(dataError.Errors.Messages[0]));
    }

    const messageError =
      dataError && dataError.length > 0 ? dataError[0] : error.message;

    throw new APIError(String(messageError));
  }
};
